













































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import HomeDown from "./down.vue";
import HomeMiddleWareHouse from "./middle-warehouse.vue";
import HomeMiddleWarning from "./middle-warning.vue";
import HomeMiddleRank from './middle-rank.vue'
class PageClientHomeRequest extends PageRequest {
  FilterText: string;
  status:number;
   StartTime: string;
  EndTime: string;
}
class DataTable {
  public columns: Array<string> = new Array<string>();
}
@Component({
  components: { HomeDown, HomeMiddleWareHouse, HomeMiddleWarning,HomeMiddleRank },
})
export default class ClientHomes extends AbpBase {
  table: DataTable = new DataTable();
  pagerequest: PageClientHomeRequest = new PageClientHomeRequest();
  //最上面的数字
  count: number = 0;
  offcount: number = 0;
  oncount: number = 0;
  lowcount: number = 0;
 //曲线图
   componentKey: number = 0;
  // legenddata: string = "";
  // xAxisdata: string = "";
  // seriesdata: string = "";
  // serieslist = [];

//饼图
  wseriesdata:string="";
  lwserieslist=[];
  wserieslist=[];
  //获取设备数量
  async getCount(status) {
    this.pagerequest.status=status;
    let num=await this.$store.dispatch({
      type: "thequipment/getCount",
      data: this.pagerequest,
    });
    switch(status){
      case 0:this.count=num;break;
      case 1:this.oncount=num;break;
      case 2:this.lowcount=num;break;
      case 3:this.offcount=num;break;
    }
  }
  showEcharts() {
    this.componentKey += 1;
  }
  list() {
    return this.$store.state.thdata.list;
  }
  async getpage() {
    let ret = await this.$store.dispatch({
      type: "data/getWareHouseList",
      data: this.pagerequest,
    });
    if (ret == 1) {
       let list = this.list();
      //console.log(list);
      var eventStartTime = new Date(this.pagerequest.StartTime);
      var eventEndTime = new Date(this.pagerequest.EndTime);
      var time = eventStartTime;
      var duration = eventEndTime.valueOf() - eventStartTime.valueOf();
      duration = duration / 1000 / 60 / 60 / 24 + 1;
      let temp = "";
      let timelist = [];
      ///下面的曲线图
      // for (let i = 0; i < duration; i++) {
      //   //console.log(this.GMTToStr(time));
      //   timelist.push(this.GMTToStr(time));
      //   if (temp != "") {
      //     temp += ",";
      //   }
      //   let row = "{";
      //   row += '"nowTime":"' + this.GMTToStr(time) + '"';
      //   let i = 0;
      //   for (let entry of this.table.columns) {
      //     //console.log(entry);
      //     let number = 0;
      //     let wId = "";
      //     for (let item of list) {
      //       wId = "wh_" + item.wId;
      //       if (
      //         this.GMTToStr(item.nowTime) == this.GMTToStr(time) &&
      //         wId == entry
      //       ) {
      //         number = item.number;
      //         break;
      //       }
      //     }
      //     //console.log(i);
      //      this.serieslist[i].data.push(number);
      //     i++;
      //     row += ',"' + entry + '":' + number + "";
      //   }
      //   row += "}";
      //   temp += row;
      //   time.setDate(time.getDate() + 1);
      // }
      //中间的饼图
      for (let i=0;i<this.lwserieslist.length;i++) {
          //console.log(entry);
          let number = 0;
          let wId = "";
          for (let item of list) {
            wId = "wh_" + item.wId;
            if (wId==this.lwserieslist[i].wId) {
              number = item.number;
              break;
            }
          }
          //console.log(i);
           this.lwserieslist[i].value+=number;
        }
        for (let entry of this.lwserieslist) {
          this.wserieslist.push({
            value:entry.value,
            name:entry.name
          });
        }
      //console.log(this.wserieslist);
      // this.seriesdata = JSON.stringify(this.serieslist);
      // this.xAxisdata = JSON.stringify(timelist);
      

       this.wseriesdata = JSON.stringify(this.wserieslist);                                                                                                              

       this.showEcharts();
    }
  }
  GMTToStr(time) {
    let date = new Date(time);
    let Str =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    return Str;
  }
   async getwarehouse() {
    //库房
    //filters
    let ret = await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagerequest,
    });
    if (ret == 1) {
      this.assemblecolumns();
    }
  }
  warehouse() {
    return this.$store.state.warehouse.list;
  }
  assemblecolumns() {
    let wlist = this.warehouse();
    let titlelist = [];
    //this.serieslist = [];
    this.wserieslist=[];
    this.table.columns = [];
    for (let entry of wlist) {
      titlelist.push(entry.wName);
      this.table.columns.push("wh_" + entry.id);
      // this.serieslist.push({
      //   name: entry.wName,
      //   type: "line",
      //   data: [],
      // });
       this.lwserieslist.push({
          value:0,
          name: entry.wName,
          wId:"wh_" + entry.id
          
       });
    }
    //this.legenddata = JSON.stringify(titlelist);
    //this.getpage();
  }
  GetTime(obj) {
    let date = new Date();
    let day = "01";
    if (obj == 1) {
      day = date.getDate() + "";
    }
    let Str = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + day;
    //date.getDate();
    return Str;
  }
  created() {
    this.getCount(0);
    this.getCount(1);
    this.getCount(2);
    this.getCount(3);
     this.pagerequest.StartTime = this.GetTime(0);
    this.pagerequest.EndTime = this.GetTime(1);
    this.getwarehouse();
  }
}
